import request from '@/utils/request'

/**
 * 用户登录
 * @param email 登录邮箱
 * @param password 登录密码
 * @returns {*}
 */
export function login(email, password) {
  return request({
    url: '/api/login',
    method: 'post',
    data: {
      email,
      password
    }
  })
}

/**
 * 获取当前登录用户的信息
 * @returns {*}
 */
export function getUserInfo() {
  return request({
    url: '/api/user',
  })
}


/**
 * 获取产品列表
 */
export function productListByCollectionId(id) {
  return request({
    url: '/api/open/productListByCollectionId/' + id,
    method: 'get'
  })
}

/**
 * 获取产品列表
 */
export function metafieldsByProductId(id) {
  return request({
    url: '/api/open/metafieldsByProductId/' + id,
    method: 'get'
  })
}

/**
 * 发送邮件
 */
export function sendEmail(form) {
  return request({
    url: '/api/open/sendEmail',
    data: form,
    method: 'post'
  })
}

export function upload(file) {
  return request({
    url: '/api/open/upload',
    data: file,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/shopify.js